/**
 * Responsible Gaming Model
 */

define(function(require, exports, module) {
    'use strict';
    var PortletModel = require('modules/portlet/portlet.model');
    var ResponsibleGamingView = require('portlets/responsible-gaming/responsible-gaming.view');

    module.exports = PortletModel.extend({

        getView: ResponsibleGamingView

    });
});